import { render, staticRenderFns } from "./addPageSaleReturn.vue?vue&type=template&id=10825a03&scoped=true&"
import script from "./addPageSaleReturn.vue?vue&type=script&lang=js&"
export * from "./addPageSaleReturn.vue?vue&type=script&lang=js&"
import style0 from "./addPageSaleReturn.vue?vue&type=style&index=0&id=10825a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10825a03",
  null
  
)

export default component.exports